import { rootRoute } from './root'
import { homeRoute } from './home'
import { ticketRoute } from './ticket'

export const feedbackRoute = rootRoute.addChildren([homeRoute, ticketRoute])
